exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".rc-slider-vertical{\n    height: 230px;\n    width: 20px;\n    margin-right: 20px;\n    display: inline-block;\n}\n\n.rc-slider-vertical {\n    \n}\n", "", {"version":3,"sources":["/home/niko/Repositories/adminlte-react/src/components/content/Inputs/Slider.css"],"names":[],"mappings":"AAAA;IACI,cAAa;IACb,YAAW;IACX,mBAAkB;IAClB,sBAAqB;CACzB;;AAEA;;CAEA","file":"Slider.css","sourcesContent":[".rc-slider-vertical{\n    height: 230px;\n    width: 20px;\n    margin-right: 20px;\n    display: inline-block;\n}\n\n.rc-slider-vertical {\n    \n}\n"],"sourceRoot":""}]);

// exports
